export const i18n = {
  en: {
    getStarted: 'Get Started',
    desc1: 'Quartz / Unix cron expressions generator',
    desc10: 'Editing a plain text crontab is error-prone for task management, such as adding tasks, deleting tasks, or pausing tasks.',
    desc11: 'A little error can undoubtedly cut down every one of the positions and could set you back a great deal of time.',
    desc2: 'React cron widget allows you to create a cron expression string without any experience or understanding of cron standards.',
    desc3: 'This library contains solutions for quartz and unix formats.',
    quartz: {
      desc1: 'Quartz cron expression is a representation of 7 values divided by single space.',
      desc2: 'Each value may have its own expression, such as 1-2, or 1,2 with various combinations of special characters.',
      desc3: 'Create a quartz cron expression with an easy-to-use online interface.'
    },
    common: {
      seconds: 'Seconds',
      minutes: 'Minutes',
      hours: 'Hours',
      dayOfMonth: 'Day Of Month',
      month: 'Month',
      dayOfWeek: 'Day Of Week',
      year: 'Year'
    },
    license: 'code licensed under the MIT License.',
    features: {
      native: {
        title: 'Native',
        desc: `
          As simple as React. Nothing else.
          The Bootstrap CSS is a optional dependency.
        `
      },
      customization: {
        title: 'Customization',
        desc: 'You can customize the component as you want.'
      },
      openSource: {
        title: 'Open-source and on npm',
        desc: 'Use it directly in your project using npm.'
      }
    }
  },
  ua: {
    getStarted: 'Початок роботи',
    desc1: 'Quartz / Unix cron builder expressions.',
    desc10: 'Редагування простого текстового crontab є схильним до помилок для керування завданнями, наприклад, додавання завдань, видалення завдань або призупинення завдань.',
    desc11: 'Невелика помилка може легко зірвати всі завдання та може коштувати вам багато часу.',
    desc2: 'Віджет інтерфейсу який дозволяє створювати вираз cron без жодного досвіду чи розуміння стандартів cron.',
    desc3: 'Ця бібліотека містить рішення для quartz та unix форматів.',
    quartz: {
      desc1: 'Quartz cron expression — це представлення семи значень, розділених одним пробілом.',
      desc2: 'Кожне значення може мати власний вираз, наприклад 1-2 або 1,2 з різними комбінаціями спеціальних символів.',
      desc3: 'Створіть quartz вираз за допомогою простого у використанні онлайн-інтерфейсу.'
    },
    common: {
      seconds: 'Секунди',
      minutes: 'Хвилини',
      hours: 'Години',
      dayOfMonth: 'День місяця',
      month: 'Місяць',
      dayOfWeek: 'День тижня',
      year: 'Рік'
    },
    license: 'код ліцензований згідно з ліцензією MIT.',
    features: {
      native: {
        title: 'Простий',
        desc: `
          Простий як React. Нічого більше.
          Bootstrap CSS не є обов'язковим.
        `
      },
      customization: {
        title: 'Налаштування',
        desc: 'Ти можеш керувати компонентом як ти хочеш.'
      },
      openSource: {
        title: 'Відкритий код та на npm',
        desc: 'Використовуй в своєму проекті за допомогою npm.'
      }
    }
  }
}
